/**
 * 인증(내 설정) 데이터 접근 repo - 내 기본 정보 조회 / 비밀번호 변경.
 * 백엔드 = /api/auth/**. 공통 응답 래퍼 { success, data, error } 에서 data 언랩하여 반환.
 */

import http from '@/services/http';

const BASE = '/api/auth';

export const myProfileRepo = {
  // 로그인 본인 기본 정보 ({ userId, loginId, empNm, empNo, email, orgNm, companyCd, roles }).
  async me() {
    const body = await http.get(`${BASE}/me`);
    return body?.data || null;
  },
  // 법인 전환 ({ companyCd }). 서버가 권한·법인 실재를 검증하고 전환 로그를 남긴다(거부 403). 응답 { companyCd, companyNm }.
  async switchCompany(companyCd) {
    const body = await http.post(`${BASE}/company-switch`, { companyCd });
    return body?.data;
  },
  // 비밀번호 변경 ({ currentPassword, newPassword }). 현재 비번 불일치 시 백엔드 400.
  async changePassword(payload) {
    await http.post(`${BASE}/password`, payload);
    return true;
  },
  // 본인 2단계 인증 설정·적용 상태 ({ tfaUseYn, tfaTypeCd, otpRegYn, otpRegDate, companyTfaUseYn, companyTfaTypeCd, adminAlwaysYn, appliedYn, appliedTypeCd, maskedEmail }).
  async tfaMe() {
    const body = await http.get(`${BASE}/tfa/me`);
    return body?.data || null;
  },
  // 본인 2단계 인증 저장 ({ tfaUseYn, tfaTypeCd, currentPassword }). 끌 때는 현재 비밀번호 필수. 회사 정책이 켜져 있으면 409. 응답 = 저장 후 상태.
  async saveTfaMe(payload) {
    const body = await http.post(`${BASE}/tfa/me`, payload);
    return body?.data || null;
  },
  // OTP 앱 등록 시작 -> { tfaTryId, secretKey, otpauthUri }
  async startOtpReg() {
    const body = await http.post(`${BASE}/tfa/me/otp/setup`, {});
    return body?.data || null;
  },
  // OTP 앱 등록 확정 ({ tfaTryId, tfaNo, currentPassword }) -> 저장 후 상태. 이미 등록된 앱을 바꿀 때는 현재 비밀번호 필수
  async confirmOtpReg(payload) {
    const body = await http.post(`${BASE}/tfa/me/otp/confirm`, payload);
    return body?.data || null;
  },
};
